import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { useRef } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { useHistory } from "react-router-dom";
import { io } from "socket.io-client";
import { serverInfo } from "../../../../../../../../App";
import useFileHandleS3 from "../../../../../../../../CustomHooks/useFileHandleS3";
import useProductImageHandleS3 from "../../../../../../../../CustomHooks/useProductImageHandleS3";
import MediaUploadProgressBar from "../../../../../../../../Screen/MediaUploadProgressBar";
import "./AddProductS.css";

const AddProductAuction = () => {

  const history = useHistory();
  const [convertedContent, setConvertedContent] = useState(null);
  const [starList, setStarList] = useState([]);
  const [errorList, setErrorList] = useState([]);
  const [loading, setLoading] = useState(false);


  // File Handle Banner
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl, fileKey, progress] = useFileHandleS3(file, 'auction/images', delKey);


  // File Handle Product Image
  const [productImage, setProductImage] = useState('');
  const [productImageDelKey, setProductImageDelKey] = useState(null);
  const [productImageUrl,productImageKey,progressBar] = useProductImageHandleS3(productImage, 'auction/images', productImageDelKey);


  

  const [inputFieldList, setInputFieldList] = useState({
    title: "",
    keyword: "",
    details: "",
    star_id: "",
    category_id: "",
    subcategory_id: "",
    base_price: "",
    bid_from: "",
    bid_to: "",
    result_date: "",
    product_delivery_date: "",
    // banner: "",
    product_image: "",
  });


  const handleInput = (e) => {
    const { name, value } = e.target;
    setInputFieldList((prev) => {
      return { ...prev, [name]: value };
    });
  };

  // Fetch Stars Added By Admin
  useEffect(() => {
    axios.get(`/api/admin/star_list`).then((res) => {
      if (res.status === 200) {
        setStarList(res.data.star);
      }
    });

  }, []);



  const bannerHandler = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };

  const productImageHandler = (file) => {
    setProductImageDelKey(productImageKey);
    setProductImage(file[0]);
  };

  const socket = useRef();
  /**
   * socket connection
   */
  const { shoketUrl } = useContext(serverInfo);
  useEffect(() => {
    socket.current = io(shoketUrl);
  }, []);

  const dataSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const fData = new FormData();

    fData.append("title", inputFieldList.title);
    fData.append("keyword", inputFieldList.keyword);
    fData.append("star_id", inputFieldList.star_id);
    fData.append("details", convertedContent);
    fData.append("base_price", inputFieldList.base_price);
    fData.append("bid_from", inputFieldList.bid_from);
    fData.append("bid_to", inputFieldList.bid_to);
    fData.append("result_date", inputFieldList.result_date);
    fData.append("product_delivery_date", inputFieldList.product_delivery_date);
    fData.append("banner", fileKey);
    fData.append("product_image", productImageKey);
    fData.append("status", 0);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/admin/add/auction/product`, fData).then((res) => {
        setLoading(false);
        if (res.data.status === 402) {
          setErrorList(res.data.errors);
        } else {
          history.push("/superstar-admin/auction/confirm-or-edit-auction");

          socket.current.emit("auction_approve", {
            id: res.data.productId,
          });
        }
      });
    });
  };

  return (
    <>
      <div className="text-light mb-3 d-flex border border-warning rounded-3 justify-content-center p-2 m-1">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning p-2">Add Product</h4>
      </div>

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form>
                  <div className="form-group row my-4">
                    <div className="col-md-3 label-text">
                      <p>Select Star</p>
                    </div>
                    <div className="col-md-9">
                      <select
                        onChange={handleInput}
                        name="star_id"
                        className="form-control reply-control"
                        value={inputFieldList.star_id}
                      >
                        <option className="text-black" value="">
                          Choose One
                        </option>
                        {starList.map((star, index) => (
                          <option className="text-black" value={star.id}>
                            {star?.first_name} {star?.last_name}
                          </option>
                        ))}
                      </select>
                      <span className="text-danger">{errorList.star_id}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Title</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        onChange={handleInput}
                        name="title"
                        value={inputFieldList.title}
                        placeholder="Enter title"
                      />
                      <span className="text-danger">{errorList.title}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Keyword</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        onChange={handleInput}
                        placeholder="Enter keyword "
                        name="keyword"
                        value={inputFieldList.keyword}
                      />
                      <span className="text-danger">{errorList.keyword}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Description</p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        editor={ClassicEditor}
                        data={convertedContent}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setConvertedContent(data);
                        }}
                      />
                      <span className="text-danger">{errorList.details}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Base Price</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        placeholder="Enter base price $"
                        type="number"
                        min={0}
                        name="base_price"
                        onChange={handleInput}
                        value={inputFieldList.base_price}
                      />
                      <span className="text-danger">
                        {errorList.base_price}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4 label-text">
                    <div className="col-md-3 label-text">
                      <p>Bidding Deadline</p>
                    </div>
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="bid_from"
                        value={inputFieldList.bid_from}
                      />
                      <span className="text-danger">{errorList?.bid_from}</span>
                    </div>{" "}
                    To
                    <div className="col-sm-4">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="bid_to"
                        value={inputFieldList.bid_to}
                      />
                      <span className="text-danger">{errorList?.bid_to}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Result Published</p>
                    </div>

                    <div className="col-sm-5">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="result_date"
                        value={inputFieldList.result_date}
                      />
                      <span className="text-danger">
                        {errorList?.result_date}
                      </span>
                    </div>
                  </div>
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Product Delivery</p>
                    </div>
                    <div className="col-sm-5">
                      <input
                        type="date"
                        className="form-control reply-controlDate"
                        onChange={handleInput}
                        name="product_delivery_date"
                        value={inputFieldList.product_delivery_date}
                      />
                      <span className="text-danger">
                        {errorList?.product_delivery_date}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Banner</>
                      </p>
                    </div>
                    <div className="col-md-5">
                      {fileUrl ? (
                        <img
                          src={fileUrl}
                          alt="..."
                          className="demo-preview-image img-fluid img-fluid"
                          style={{
                            height: "200px",
                            width: "300px",
                          }}
                        />
                      ) : (
                        ""
                      )}
                      <input
                        className="form-control reply-control"
                        type="file"
                        accept="image/*"
                        onChange={(e) => bannerHandler(e.target.files)}
                      />
                        {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                      <span className="text-danger">{errorList.image}</span>
                    </div>
                  </div>

                   <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Product Image</>
                      </p>
                    </div>
                    <div className="col-md-5">
                      {productImageUrl ? (
                        <img
                          src={productImageUrl}
                          alt="..."
                          className="demo-preview-image img-fluid img-fluid"
                          style={{
                            height: "200px",
                            width: "300px",
                          }}
                        />
                      ) : (
                        ""
                      )}
                      <input
                        className="form-control reply-control"
                        type="file"
                        accept="image/*"
                        onChange={(e) => productImageHandler(e.target.files)}
                      />
                        {productImage && !productImageUrl && <MediaUploadProgressBar progress={progressBar} />}
                      <span className="text-danger">{errorList.image}</span>
                    </div>
                  </div>

                  {/* Create Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnCreate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button
                          className="btn btnCreate fw-bold"
                          onClick={dataSubmit}
                          type="submit"
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Create Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProductAuction;
